import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import AuthProvider from './auth/AuthProvider';
import ProtectedRoute from './auth/ProtectedRoute';
import WhitelistGuard from './auth/WhitelistGuard';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import UnauthorizedPage from './pages/UnauthorizedPage';
import DashboardPage from './pages/DashboardPage';
import ListaDeEmailsPage, { LISTAS } from './pages/admin/ListaDeEmailsPage';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/unauthorized" element={<UnauthorizedPage />} />

          <Route
            path="/admin"
            element={
              <ProtectedRoute requireAdmin={true}>
                <Layout>
                  <ListaDeEmailsPage key="acesso" lista={LISTAS.acessoDashboard} />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/cortesias"
            element={
              <ProtectedRoute requireAdmin={true}>
                <Layout>
                  <ListaDeEmailsPage key="cortesia" lista={LISTAS.cortesia} />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <WhitelistGuard>
                  <Layout>
                    <DashboardPage />
                  </Layout>
                </WhitelistGuard>
              </ProtectedRoute>
            }
          />

          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
